import { api } from './api';

/**
 * Download a file from the API as a blob and trigger browser download.
 * Uses the raw `api` axios instance (not `apiClient`) because blob downloads
 * need access to the full AxiosResponse to extract response.data as Blob.
 * Auth interceptors are still applied since `api` has them configured.
 */
export async function downloadBlob(url: string, filename: string): Promise<void> {
  const response = await api.get(url, { responseType: 'blob' });
  const blob = response.data as Blob;
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}

/**
 * Download multiple files sequentially, calling onProgress between each.
 * Returns the count of successfully downloaded files.
 */
export async function downloadMultiple(
  files: { url: string; filename: string }[],
  onProgress?: (current: number, total: number) => void,
): Promise<number> {
  let succeeded = 0;
  for (let i = 0; i < files.length; i++) {
    onProgress?.(i + 1, files.length);
    try {
      await downloadBlob(files[i].url, files[i].filename);
      succeeded++;
    } catch {
      // Continue with remaining files on error
    }
  }
  return succeeded;
}
